export default "__VITE_ASSET__ff18037f__"